jQuery(function ($) {
  let $slider = $('.enterprise-ratings .logos-wrapper');
  let slickInitialized = false;

  function initSlick() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      if (!slickInitialized) {
        $slider.slick({
          dots: false,
          arrows: false,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 1000,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: false
        });
        slickInitialized = true;
      } else {
        $slider.slick('setPosition');
      }
    } else {
      if (slickInitialized) {
        $slider.slick('unslick');
        slickInitialized = false;
      }
    }
  }

  setTimeout(initSlick, 300);

  $(window).on('resize', initSlick);
  $(window).on('load', initSlick);
});
